import { useSyncExternalStore } from "react";

import { getSyncState, subscribeSync } from "./syncManager";

/** Subscribe a component to the live sync state (online / pending / syncing). */
export function useSyncStatus() {
  return useSyncExternalStore(subscribeSync, getSyncState, getSyncState);
}
